export default {
  // 中文配置
  delete_success: '删除成功',
  delete_failed: '删除失败',
  you_will_need_to: '您需要：',
  add_new_admin_or_del_all_titles: '添加新管理员或删除所有游戏',
  delete_account: '删除账户',
  only_user_or_owner_desc: '如果您是工作室中唯一的用户或所有者，您需要：',
  add_admin_or_del_all: 'a) 添加新管理员 或者 b) 删除所有游戏',
  process_irreversible_desc:
    '此过程不可逆，可能需要几分钟才能完成，当账户完全删除后，您将收到一封电子邮件。',
  sure_delete_account: '确定要删除您的 InGame 账户吗？',
  email_address: '邮箱账户',
  change_password: '更改密码',
  registration_time: '注册时间(UTC)',
  registration_time_local: '注册时间',
  click_del_account_desc: '点击“删除我的账户”将永久删除您的 InGame 账户。',
  click_del_support_account_desc:
    '点击“删除账户”将永久删除您的 InGame Support 账户。',
  edit_name_success: '编辑显示名称成功！',
  reset_password_success: '重置密码成功',
  reset_password_fail: '重置密码失败',
  old_password_try_again: '旧密码错误。请再试一次。',
  Identity_verification_expired: '身份验证已过期，请再试一次。',
  current_password: '当前密码',
  input_your_password: '请输入您的密码！',
  enter_your_password: '请输入您的密码',
  new_password: '新密码',
  enter_new_password: '请输入您的新密码',
  confirm_password: '确认密码',
  passwords_not_match: '密码不匹配。请再试一次。',
  please_repeat_password: '请重复输入密码',
  time_zone_setting: '时区设置',
  time_zone_setting_desc:
    '该设置为用户个人浏览器时区设定，修改其配置不会影响配置生效逻辑，仅影响控制台时间显示。',
  please_enter_city: '请输入城市',
};
